import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=4a82624a&scoped=true&"
import script from "./DownloadCard.vue?vue&type=script&lang=ts&"
export * from "./DownloadCard.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadCard.vue?vue&type=style&index=0&id=4a82624a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a82624a",
  null
  
)

export default component.exports